import axios from 'axios';
const url: any = 'https://' + sessionStorage.getItem('domain');


const lang = localStorage.getItem('lang') === 'zh_CN' ? 'zh_CN' : 'en_US';

const http = axios.create({
    baseURL:  url, // API的基础路径
    timeout: 10000, // 请求超时时间
    headers: {
        // 设置后端需要的传参类型
        'Content-Type': 'application/json',
        'Exchange-Language': lang
    },
});
export default http;

// 创建axios实例
